export default __webpack_public_path__ + "static/media/3_1.294418de.jpg";